var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.802,
    height: 19.802,
    viewBox: "0 0 19.802 19.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diskette_2874050",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50464",
    "data-name": "Path 50464",
    d: "M20.61,5.152l-3.96-3.96A.66.66,0,0,0,16.181,1h-1.32V6.28a1.32,1.32,0,0,1-1.32,1.32H8.261a1.32,1.32,0,0,1-1.32-1.32V1H2.98A1.98,1.98,0,0,0,1,2.98V18.822A1.98,1.98,0,0,0,2.98,20.8H4.3V14.861a1.98,1.98,0,0,1,1.98-1.98h9.241a1.98,1.98,0,0,1,1.98,1.98V20.8h1.32a1.98,1.98,0,0,0,1.98-1.98V5.62a.66.66,0,0,0-.191-.469Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50465",
    "data-name": "Path 50465",
    d: "M12,1h5.28V6.28H12Z",
    transform: "translate(-3.739 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50466",
    "data-name": "Path 50466",
    d: "M17.9,21H8.66a.66.66,0,0,0-.66.66V27.6H18.561V21.66A.66.66,0,0,0,17.9,21Z",
    transform: "translate(-2.38 -6.799)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/SaveIcon.ab81e9f26d3db31bb80dea1e192ffb0d.svg";
export { ForwardRef as ReactComponent };